/**
 * Formats a duration value from DurationInput into a human-readable format
 * @param value - The duration value (e.g., '2M', '4W', '1Y')
 * @returns Formatted string (e.g., '2 Months', '4 Weeks', '1 Year') or empty string if invalid
 */
export function formatExtendedDurationValue(value: string | undefined, prefix = ''): string {
  if (!value) {
    return '';
  }

  const match = value.match(/^(\d+)([A-Za-z])$/);
  if (!match) {
    return '';
  }

  const [, number, unit] = match;
  const num = parseInt(number, 10);
  let label = '';
  switch (unit.toUpperCase()) {
    case 'H':
      label = `${num} ${num === 1 ? 'hour' : 'hours'}`;
      break;
    case 'D':
      label = `${num} ${num === 1 ? 'day' : 'days'}`;
      break;
    case 'W':
      label = `${num} ${num === 1 ? 'week' : 'weeks'}`;
      break;
    case 'M':
      label = `${num} ${num === 1 ? 'month' : 'months'}`;
      break;
    case 'Y':
      label = `${num} ${num === 1 ? 'year' : 'years'}`;
      break;
    default:
      return '';
  }
  if (label && prefix) {
    return `${prefix} ${label}`;
  }
  return label;
}
